import { useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { useConfig } from "../../context/ConfigContext";
import "./styles.css";
import { ProductRecommendation } from "../ProductRecommendation/ProductRecommendation";
import { ProductCart } from "../ProductCart/ProductCart";

export const ProductReviewFlow = ({
  results,
  recommendedProducts,
  showAiResults,
  updateProductsInfo,
}) => {
  const { logo, configData } = useConfig();
  const [reviewStep, setReviewStep] = useState(0);

  return (
    <div className="product-review-flow">
      <div className="logo-bar">
        <div className="products-back-button-wrapper">
          <IoChevronBackOutline
            className="back-icon"
            onClick={() =>
              reviewStep === 0 ? showAiResults() : setReviewStep(0)
            }
          />
        </div>
        {configData?.ProductRecommendationFlag?.logoEnabled !== false ? (
          <img
            className="logo-img"
            src={
              configData?.ProductRecommendationFlag?.logoUrl
                ? configData?.ProductRecommendationFlag?.logoUrl
                : logo
            }
            alt="Logo"
          />
        ) : null}
      </div>
      {reviewStep === 1 ? (
        <ProductCart
          recommendedProducts={recommendedProducts}
          onProductSelect={updateProductsInfo}
        />
      ) : (
        <ProductRecommendation
          results={results}
          recommendedProducts={recommendedProducts}
          onContinue={(newProductsInfo) => {
            setReviewStep(1);
            updateProductsInfo(newProductsInfo);
          }}
        />
      )}
    </div>
  );
};
